<template>
    <div>
        <page-title :title="$t('jobs.title')"></page-title>

        <template v-for="section in sections" :key="section.type">
            <div class="mt-4 mb-3 text-xl">
                <h2>{{ section.type }}</h2>
            </div>
            <div class="bg-white shadow overflow-hidden sm:rounded-md">
                <ul class="divide-y divide-gray-200">

                    <li v-for="job in section.jobs" :key="job.name">
                        <div class="px-4 py-4 sm:px-6 hover:bg-gray-50">
                            <div class="flex items-center justify-between">
                                <p class="text-sm font-medium text-cyan-600 truncate">
                                    {{ job.name }}
                                </p>
                            </div>
                            <div>
                                <p class="text-sm font-medium truncate">
                                    {{ job.desc }}
                                </p>
                            </div>
                            <div class="mt-2 sm:flex sm:justify-between">
                                <div class="sm:flex">
                                    <p class="flex items-center text-sm text-gray-500">
                                        <ArrowLeftOnRectangleIcon
                                            class="mr-1.5 h-5 w-5 text-gray-400"></ArrowLeftOnRectangleIcon>
                                        {{ job.input }}
                                    </p>
                                    <p class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6">
                                        <ArrowRightOnRectangleIcon
                                            class="mr-1.5 h-5 w-5 text-gray-400"></ArrowRightOnRectangleIcon>
                                        {{ job.output }}
                                    </p>
                                </div>
                                <div class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0">
                                    <jet-button @click="dispatch({action: job.action})">
                                        {{ $t('actions.dispatch') }}
                                    </jet-button>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </template>
    </div>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import PageTitle from "@/Shared/Components/PageTitle";
import {ArrowLeftOnRectangleIcon, ArrowRightOnRectangleIcon} from "@heroicons/vue/24/outline";
import JetButton from "@/Jetstream/PrimaryButton";
import {router} from "@inertiajs/vue3";

export default {
    components: {
        PageTitle,
        ArrowLeftOnRectangleIcon,
        ArrowRightOnRectangleIcon,
        JetButton
    },
    layout: AppLayout,
    props: ['sections'],
    methods: {
        dispatch(payload) {
            router.put(this.route('settings.jobs.dispatch'), payload, {
                onSuccess: () => this.$notify({
                    group: "main",
                    title: 'actions.success',
                    text: 'jobs.dispatched'
                }, 2000)
            });
        },
    },
}
</script>

<style scoped>

</style>
